import { Paginator } from '@app/classes';
import { TaxCredit as TaxCreditModel } from '@app/models/employee/payroll/tax-credit.model';
import { Table } from '@app/modules/table/classes/table.class';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import { Jurisdiction } from '@app/types/province';
import { Locale } from '@app/types/translatable.type';
import { FederalColumns, ProvincialColumns } from './columns';

export type TaxCreditTableEvent = 'view' | 'deactivate';

export class TaxCreditTable extends Table<TaxCreditModel> {
    static viewDetailsOption: MenuColumnItem<TaxCreditTableEvent> = {
        label: 'employees.jobAndPay.taxCredits.tableActions.viewDetails',
        event: 'view',
        forceMeatballsDisplay: true,
    };

    static deactivateOption: MenuColumnItem<TaxCreditTableEvent> = {
        label: 'employees.jobAndPay.taxCredits.tableActions.deactivate.label',
        event: 'deactivate',
        forceMeatballsDisplay: true,
    };

    showMenuColumnOptions = true;

    constructor(
        private employeeId: number,
        private jurisdiction: Jurisdiction,
        private locale: Locale
    ) {
        super();
        this.boot();
    }

    private get isFederal(): boolean {
        return this.jurisdiction === 'federal';
    }

    setColumns(): void {
        const columns = this.isFederal ? FederalColumns : ProvincialColumns;
        this.columns = columns.map((Column) => new Column(this.locale));
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            TaxCreditModel.query().param('employee', this.employeeId).where('isFederal', this.isFederal)
        );
    }

    getMenuColumnOptionsForRow(taxCredit: TaxCreditModel): MenuColumnItem<TaxCreditTableEvent>[] {
        const options = [TaxCreditTable.viewDetailsOption];

        // Can only deactivate active tax credits
        if (taxCredit.state === 'active') {
            options.push(TaxCreditTable.deactivateOption);
        }

        return options;
    }
}
